import { useTranslate } from "ra-core";
import { Link } from "react-router";
import { formatDuration } from "../domain/format";
import { elapsedSeconds } from "../domain/sessions/teamSessions";
import { useLiveSessions } from "../reports/sessions/useLiveSessions";
import { sessionHref, sessionsHref } from "../reports/sessions/sessionLinks";
import { useNow } from "./useNow";

/** GAVION team sessions: « En session » on the admin Team view — who is dialing now, linking to Rapports → Sessions. */
export const LiveSessionsCard = () => {
  const t = useTranslate();
  const now = useNow(1000);
  const q = useLiveSessions(30_000);
  if (q.isPending || q.isError || !q.data) return null; // the dashboard never fails on this card
  const d = (k: string) => t(`gavion.sessions.dashboard.${k}`);
  return (
    <section
      aria-labelledby="dashboard-live-sessions"
      className="flex flex-wrap items-center gap-x-4 gap-y-2 rounded-xl border bg-card px-4 py-3 text-sm"
    >
      <h2 id="dashboard-live-sessions" className="font-bold">
        {d("title")}
      </h2>
      {q.data.length === 0 ? (
        <p className="text-muted-foreground">{d("none")}</p>
      ) : (
        <ul aria-label={d("title")} className="flex flex-wrap gap-x-4 gap-y-1">
          {q.data.map((s) => (
            <li key={s.id}>
              <Link
                to={sessionHref(s.id)}
                className="font-semibold underline underline-offset-4"
              >
                {s.name}
              </Link>{" "}
              <span className="tabular-nums text-muted-foreground">
                {formatDuration(elapsedSeconds(s.started_at, now))}
                {s.paused ? ` · ${t("gavion.sessions.live.paused")}` : ""}
              </span>
            </li>
          ))}
        </ul>
      )}
      <Link
        to={sessionsHref(null)}
        className="ml-auto inline-flex min-h-11 items-center font-semibold text-accent-foreground underline underline-offset-4 md:min-h-0"
      >
        {d("link")}
      </Link>
    </section>
  );
};
